import React, { useContext } from "react";
import HelmetComponent from "../components/common/HelmetComponent";
import "../styles/termsOfService.css";
import { WebsiteContext } from "../context/AppContext";
import { HiShieldCheck } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

const termsContent = [
  {
    title: "1. Acceptance of Terms",
    content:
      "By accessing or using the Fluent Fable App or website, you agree to be bound by these Terms & Conditions, our Privacy Policy, and all applicable laws and regulations. If you do not agree with any part of these terms, you should not access our services.",
  },
  {
    title: "2. Description of Educational Service",
    content:
      "The Fluent Fable platform provides users with interactive educational tools to build English speaking and language fluency. This includes AI-assisted practice conversations, daily quote insights, grammar and vocabulary quizzes, audio pronunciations, and structured learning paths.",
  },
  {
    title: "3. User Conduct & Acceptable Use",
    content:
      "Users agree to utilize Fluent Fable for lawful, educational purposes only. You must not submit unlawful, abusive, or harmful prompts, impersonate others, or attempt to disrupt the servers, API endpoints, or infrastructure supporting the service.",
  },
  {
    title: "4. Intellectual Property Rights",
    content:
      "All proprietary software, logos, curated lesson curricula, 3D assets, and interactive educational content provided through Fluent Fable remain the exclusive property of Fluent Fable and are protected by applicable copyright and trademark laws.",
  },
  {
    title: "5. User Submissions & Feedback",
    content:
      "When you share questions, reviews, or feedback, you grant Fluent Fable a non-exclusive right to utilize this feedback to train our pedagogical models and enhance the learning experience for all members.",
  },
  {
    title: "6. Modifications to Service",
    content:
      "Fluent Fable reserves the right to enhance, modify, or discontinue any feature, practice mode, or course syllabus at any time in order to improve educational effectiveness.",
  },
  {
    title: "7. Limitation of Liability",
    content:
      "Fluent Fable and its educators shall not be liable for any indirect, incidental, or consequential damages resulting from your use of or inability to access the service.",
  },
];

const TermsOfService = () => {
  const { color, dark } = useContext(WebsiteContext);
  const navigate = useNavigate();

  return (
    <>
      <HelmetComponent
        title="Terms of Service | Fluent Fable"
        name="description"
        content="Read the terms and conditions governing the use of the Fluent Fable application and website."
      />

      <div className="legal_page_wrapper">
        <div className="legal_hero_header">
          <span className={`legal_badge ${dark ? "legal_badge_dark" : "legal_badge_light"}`}>
            <HiShieldCheck size={16} /> Legal Agreement
          </span>
          <h1 className="legal_main_title" style={{ color: color }}>
            Terms of Service
          </h1>
          <p className="legal_last_updated" style={{ color: color }}>
            Last Updated: October 2026
          </p>
          <p className="legal_intro_text" style={{ color: color }}>
            Please read these terms carefully before using Fluent Fable. They establish the legal guidelines ensuring a secure and respectful learning environment for all users.
          </p>
        </div>

        <div className="legal_sections_stack">
          {termsContent.map((item, index) => (
            <div
              key={index}
              className={`legal_section_card ${dark ? "card_dark" : "card_light"}`}
            >
              <h2 className="legal_section_title">{item.title}</h2>
              <p className="legal_section_body" style={{ color: color }}>
                {item.content}
              </p>
            </div>
          ))}
        </div>

        <div className={`legal_support_box ${dark ? "card_dark" : ""}`}>
          <h3 className="support_box_title" style={{ color: color }}>
            Questions About Our Terms?
          </h3>
          <p className="support_box_desc" style={{ color: color }}>
            If you have questions or need clarification regarding our terms of service, reach out to our legal and support team.
          </p>
          <span
            className="support_email_link"
            onClick={() => navigate("/contact")}
          >
            Contact Our Support Team →
          </span>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
